// Footer.js
import React from 'react';
import { Link, Stack, StackItem } from '@fluentui/react';
import { footerStyle } from './style';
import { APP_SETTINGS } from '../../config/config';

const links = APP_SETTINGS.FOOTER_LINKS;

const Footer = () => (
  <footer className={footerStyle.footer}>
    <Stack horizontal horizontalAlign="space-between" className={footerStyle.linkContainer}>
      {links.map(({ prefix, href, text }, i) => (
        <StackItem key={i}>
          <>
            {prefix}
            <Link href={href} className={footerStyle.link} rel="noopener noreferrer" target="_blank">{text}</Link>
          </>
        </StackItem>
      ))}
      <StackItem>Microsoft Confidential | © {new Date().getFullYear()}</StackItem>
    </Stack>
  </footer>
);

export default Footer;
